<template>
  <div>
    <div align="left">
      <br />
      <h5 class="font-weight-bold text-primary">Registration Button</h5>
      <br />
    </div>
    <b-card class="text-left">
      <b-row class="mt-4">
        <b-col md="6">
          <b-form-group
            id="fieldset-heading_id"
            label="Heading (Bahasa)"
            label-class="control-label"
            class="required"
            label-for="input-heading_id"
          >
            <input
              v-validate="'required'"
              v-model="item.heading.id"
              name="heading_id"
              data-vv-as="Heading Bahasa"
              id="input-heading_id"
              class="form-control"
              placeholder="Heading In Bahasa Indonesia"
            />
            <b-form-invalid-feedback id="input-heading_id-feedback">{{
              veeErrors.first("heading_id")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="fieldset-heading_en"
            label="Heading (English)"
            label-class="control-label"
            class="required"
            label-for="input-heading_en"
          >
            <input
              v-validate="'required'"
              v-model="item.heading.en"
              name="heading_en"
              data-vv-as="Heading English"
              class="form-control"
              placeholder="Button Text In English"
            />
            <b-form-invalid-feedback id="input-heading_en-feedback">{{
              veeErrors.first("heading_en")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col md="6">
          <b-form-group
            id="fieldset-button_text_id"
            label="Button Text (Bahasa)"
            label-class="control-label"
            class="required"
            label-for="input-button_text_id"
          >
            <input
              v-validate="'required'"
              v-model="item.button_text.id"
              name="button_text_id"
              data-vv-as="Button Text Bahasa"
              id="input-button_text_id"
              class="form-control"
              placeholder="Button Text In Bahasa Indonesia"
            />
            <b-form-invalid-feedback id="input-button_text_id-feedback">{{
              veeErrors.first("button_text_id")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="fieldset-button_text_en"
            label="Button Text (English)"
            label-class="control-label"
            class="required"
            label-for="input-button_text_en"
          >
            <input
              v-validate="'required'"
              v-model="item.button_text.en"
              name="button_text_en"
              data-vv-as="Button Text English"
              class="form-control"
              placeholder="Button Text In English"
            />
            <b-form-invalid-feedback id="input-button_text_en-feedback">{{
              veeErrors.first("button_text_en")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col md="6">
          <b-form-group
            id="fieldset-button_url"
            label="Button URL"
            label-class="control-label"
            class="required"
            label-for="input-button_url"
          >
            <input
              v-validate="'required'"
              v-model="item.button_url"
              name="button_url"
              data-vv-as="Button URL"
              class="form-control"
              placeholder="Button URL"
            />
            <b-form-invalid-feedback id="input-button_url-feedback">{{
              veeErrors.first("button_url")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <br />
      <br />
      <b-row class="text-right">
        <b-col md="2" class="text-left">
          <label class="text-danger">
            *
            <b class="text-dark">Required</b>
          </label>
        </b-col>
        <b-col>
          <b-button
            variant="primary"
            :disabled="loading"
            @click="post()"
            class="mr-3"
            size="lg"
          >
            Update
            <b-spinner v-if="loading" small label="Loading..."></b-spinner>
          </b-button>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>

export default {
  data() {
    return {
      loading: false,
      item: {
        heading: {
          id: '',
          en: '',
        },
        button_text: {
          id: '',
          en: '',
        },
        button_url: '',
      },
    };
  },
  beforeCreate() {
    this.$store.dispatch(
      "PaxelBigRegistrationButtonModule/getBigRegistrationButton"
    );
  },
  created() {
    this.$store.watch(
      (state) => state.PaxelBigRegistrationButtonModule.registration_button,
      (newValue, oldValue) => {
        this.item = newValue;
      }
    );
  },
  methods: {
    post() {
      this.$swal({
        title: "Are you sure?",
        text: "You will update this Paxel Big Registration Button !",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, update it!",
      }).then((result) => {
        if (result.value) {
          this.$validator.validateAll().then((result) => {
            if (result) {
              this.loading = true;
              const formData = new FormData();
              formData.append("heading_id", this.item.heading.id);
              formData.append("heading_en", this.item.heading.en);
              formData.append("button_text_id", this.item.button_text.id);
              formData.append("button_text_en", this.item.button_text.en);
              formData.append("button_url", this.item.button_url);
              this.$store
                .dispatch("PaxelBigRegistrationButtonModule/postBigRegistrationButton", formData)
                .then((response) => {
                  this.loading = false;
                  this.$swal({
                    type: "success",
                    title: "Your work has been saved",
                    showConfirmButton: false,
                    timer: 1500,
                  });
                })
                .catch((error) => {
                  this.loading = false;
                  this.$swal({
                    type: "error",
                    title: "Oops...",
                    text: error.response.data.data[0],
                    showConfirmButton: false,
                    timer: 1500,
                  });
                  console.log(error.response.data);
                });
            } else {
              this.$swal("ERROR!", "Your data cant be submit.", "warning");
            }
          });
        }
      });
    },
  },
};
</script>

<style>
</style>
